import React from 'react';
import './App.css';

import "weather-icons/css/weather-icons.css"
import "bootstrap/dist/css/bootstrap.min.css"
import Weather from './app.component/weather.comp';
import Form from './app.component/form.comp';

//api call `https://api.openweathermap.org/data/2.5/weather?q=Lagos&limit=5&appid=ddbe9a03fe470721c154bd85a9fbfb18`

class App extends React.Component {
  constructor(){
    super();
    this.state = {
      city: undefined,
      country: undefined,
      icon: undefined,
      main: undefined,
      celsius: undefined,
      temp_max: undefined,
      temp_min:undefined,
      description: "",
      error: false
    };
    
    this.weatherIcon = {
      Thunderstorm: "wi-thunderstorm",
      Drizzle: "wi-sleet",
      Rain: "wi-storm-showers",
      Snow: "wi-snow",
      Atmosphere: "wi-fog",
      Clear: "wi-day-sunny",
      Clouds: "wi-day-fog"
    }
  };

  get_WeatherIcon(icons, rangeId){
    switch(true){
    case rangeId >= 200 && rangeId <= 232:
      this.setState({icon:this.weatherIcon.Thunderstorm});
      break;
    case rangeId >= 300 && rangeId <= 321:
      this.setState({icon:this.weatherIcon.Drizzle});
      break;
    case rangeId >= 500 && rangeId <= 531:
        this.setState({icon:this.weatherIcon.Rain});
        break;
    case rangeId >= 600 && rangeId <= 622:
      this.setState({icon:this.weatherIcon.Snow});
      break;
    case rangeId >= 701 && rangeId <= 781:
      this.setState({icon:this.weatherIcon.Atmosphere});
      break;
    case rangeId === 800:
      this.setState({icon:this.weatherIcon.Clear});
      break;
    case rangeId >= 801 && rangeId <= 804:
      this.setState({icon:this.weatherIcon.Clouds});
      break;
    default:
      this.setState({icon:this.weatherIcon.Clouds});
    }
  }

   
  calCelsius(temp){
  let cell = Math.floor(temp - 273.15)
  return cell ;
  }

  getWeather = async (e) => {
    e.preventDefault();
    const country = e.target.elements.country.value;
    const city = e.target.elements.city.value;
    
    if(city && country){
      const api_call= await fetch (
        `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&limit=5&appid=ddbe9a03fe470721c154bd85a9fbfb18`
        );
    
      const response = await api_call.json();
  
      this.setState({
        city: `${response.name}, ${response.sys.country}`,
        country: response.sys.country,
        main: response.weather[0].main,
        celsius: this.calCelsius(response.main.temp),
        temp_max: this.calCelsius(response.main.temp_max),
        temp_min: this.calCelsius(response.main.temp_min),
        description: response.weather[0].description,
        error: false
      });

      //
      this.get_WeatherIcon(this.weatherIcon,response.weather[0].id);
      console.log(response);  
    } else{
      this.setState({
        error: true
      });
    }
};

  render() {
    return( 
      <div className="App">
      <div className='header'>
        <h1>Weather Report Application</h1>
        <p>Check the current status of the weather report of your prefered city.</p>
      </div>
      <Form loadweather= {this.getWeather} error={this.state.error}/>
      <Weather 
          cityname={this.state.city}
          weatherIcon={this.state.icon}
          temp_celsius={this.state.celsius}
          temp_max={this.state.temp_max}
          temp_min={this.state.temp_min}
          description={this.state.description}
        />
    </div>
    );
  }
};

export default App;
